<template>
  <div class="dashboard-view">
    <div class="page-wrapper oauth-result">
      <div class="result-card">
        <div class="icon-wrapper success">
          <unicon name="check-circle"></unicon>
        </div>
        <h3>Connected Successfully</h3>
        <p>
          <strong>{{ providerName }}</strong> has been connected to your account.
        </p>
        <router-link to="/integrations" class="btn btn-small btn-grey">
          Back to Integrations
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OAuthSuccess",
  computed: {
    providerName() {
      const provider = this.$route.query.provider || "";
      return provider.charAt(0).toUpperCase() + provider.slice(1).replace(/_/g, " ");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.oauth-result {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem;
}

.result-card {
  text-align: center;
  max-width: 24rem;

  h3 {
    margin-bottom: 0.5rem;
  }

  p {
    margin-bottom: 1.5rem;
    color: $paragraphColor;
  }
}

.icon-wrapper {
  margin-bottom: 1.5rem;

  ::v-deep svg {
    width: 3rem;
    height: auto;
  }

  &.success ::v-deep svg {
    fill: $greenColor;
  }
}
</style>
